'use client';

import { format } from 'date-fns';
import { formatCalendarEventDisplayTitle } from '@/app/(main)/calendar/utils/formatCalendarEventDisplayTitle';
import { Modal } from '@/app/components/Modal';
import { BaseButton } from '@/app/components/buttons/BaseButton';
import type { CalendarEvent } from '@/types/calendarTypes';
import BirthdayIcon from '/public/icons/birthday.svg';
import ClockIcon from '/public/icons/clock.svg';

type CalendarBirthdaysModalProps = {
  date: Date | null;
  birthdays: CalendarEvent[];
  isOpen: boolean;
  onClose: () => void;
};

export function CalendarBirthdaysModal({ date, birthdays, isOpen, onClose }: CalendarBirthdaysModalProps) {
  if (!date) return null;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="flex flex-col w-[min(100vw-32px,480px)] max-h-[min(800px,90vh)] overflow-hidden">
        <div className="flex flex-col md:px-9 px-4 pt-11.5 shrink-0">
          <p className="font-inter font-medium md:text-xl text-base text-black mb-2 pr-8">Birthdays</p>
          <div className="flex items-center gap-2">
            <ClockIcon className="w-6 h-6 stroke-black" />
            <p className="md:text-body-regular text-body-small text-blue-300">{format(date, 'EEEE, MMMM d, yyyy')}</p>
          </div>
        </div>
        <ul className="flex flex-col gap-2 mt-2 md:px-9 px-4 overflow-y-auto flex-1 min-h-0">
          {birthdays.map((birthday) => (
            <li
              key={birthday.id}
              className="inline-flex items-center gap-2 rounded-[100px] bg-green-100 text-status-success px-3 py-1.5 text-body-small w-fit max-w-full"
            >
              <BirthdayIcon className="h-4 w-4 shrink-0 text-status-success" aria-hidden />
              <span className="truncate">{formatCalendarEventDisplayTitle(birthday)}</span>
            </li>
          ))}
        </ul>
        <div className="md:px-9 px-4 md:pb-11.5 pb-6 md:pt-9 pt-6 shrink-0">
          <BaseButton className="w-full" onClick={onClose}>
            Close
          </BaseButton>
        </div>
      </div>
    </Modal>
  );
}